import { MedplumClient } from "@medplum/core";

import { QuiltedHealthCodes } from "@/fhir/enums/quilted-health";
import { Systems } from "@/fhir/enums/systems";

export const fetchBirthDateTimeObservation = async (medplum: MedplumClient, clientId: string) => {
  const birthingObservation = await medplum.searchOne("Observation", {
    subject: `Patient/${clientId}`,
    code: `${Systems.QH}|${QuiltedHealthCodes.BirthDateTime}`,
    "status:not": "cancelled",
    _sort: "-_lastUpdated",
  });

  return birthingObservation;
};
